module.exports = __webpack_public_path__ + "fonts/Manrope-400-cyrillic2_efc8e8d.woff2";